import { useNavigate } from "react-router-dom";
import { useLang } from "@/i18n";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  const { t } = useLang();
  const navigate = useNavigate();
  return (
    <div className="max-w-md mx-auto pt-16 md:pl-14" data-testid="payment-cancel-page">
      <div className="bg-card border rounded-2xl p-8 text-center space-y-4 animate-fade-up">
        <XCircle className="h-14 w-14 text-amber-600 mx-auto" />
        <h1 className="font-display text-2xl font-extrabold">{t("pay.cancelTitle")}</h1>
        <p className="text-sm text-muted-foreground">{t("pay.cancelBody")}</p>
        <Button data-testid="payment-cancel-plans" onClick={() => navigate("/prezzi")}
          className="w-full h-12 tactile-btn font-bold">{t("pay.backPlans")}</Button>
      </div>
    </div>
  );
}
